<template>
  <div>
    <SidePanel
      importStyle="App"
      ctaTitle="Continue shopping"
      :ctaAction="gotoHomepage"
      :ctaActionDisabled="false"
      :closeModal="onClose"
    >
      <template #modalTitle>
        <div :class="`${classVariableName}-panel-title`">Review submitted</div>
      </template>

      <template #default>
        <div :class="`${classVariableName}-review-success-container`">
          <div>
            <svg
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <mask
                id="mask0_781_94451"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="17"
                y="11"
                width="52"
                height="50"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M42.6964 60.508C42.3859 60.508 42.0778 60.4329 41.7973 60.2801C41.0134 59.8518 22.5471 49.6732 18.0464 35.6626C18.0439 35.6626 18.0439 35.6601 18.0439 35.6601C15.2187 26.839 18.3645 15.7538 28.5205 12.4803C33.2892 10.9375 38.4862 11.6162 42.6889 14.2686C46.7614 11.6939 52.1712 10.9826 56.8448 12.4803C67.0108 15.7588 70.1666 26.8415 67.344 35.6601C62.9885 49.5105 44.387 59.8418 43.5981 60.2751C43.3176 60.4304 43.007 60.508 42.6964 60.508Z"
                  fill="#D9D9D9"
                />
              </mask>
              <g mask="url(#mask0_781_94451)">
                <rect
                  width="83.9765"
                  height="78.5437"
                  rx="12.8"
                  transform="matrix(-4.37114e-08 -1 0.997735 -0.0672723 -6.54297 86.5488)"
                  fill="url(#paint0_linear_781_94451)"
                />
                <rect
                  width="83.9765"
                  height="78.5437"
                  rx="12.8"
                  transform="matrix(-4.37114e-08 -1 0.997735 -0.0672723 -6.54297 86.5488)"
                  fill="url(#pattern0)"
                  fill-opacity="0.6"
                />
              </g>
              <mask id="path-3-inside-1_781_94451" fill="white">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M36.5864 68.3331C36.2846 68.3331 35.9851 68.2601 35.7125 68.1116C34.9506 67.6953 17.0024 57.8023 12.6279 44.1847C12.6255 44.1847 12.6255 44.1823 12.6255 44.1823C9.87961 35.6087 12.9371 24.8344 22.8082 21.6528C27.4432 20.1532 32.4943 20.8129 36.5791 23.3909C40.5373 20.8884 45.7954 20.197 50.3378 21.6528C60.2187 24.8393 63.2859 35.6111 60.5425 44.1823C56.3092 57.644 38.2296 67.6856 37.4628 68.1067C37.1901 68.2576 36.8883 68.3331 36.5864 68.3331Z"
                />
              </mask>
              <path
                d="M36.5864 71.5331C38.3537 71.5331 39.7864 70.1004 39.7864 68.3331C39.7864 66.5658 38.3537 65.1331 36.5864 65.1331V71.5331ZM35.7125 68.1116L34.1783 70.9198L34.1819 70.9218L35.7125 68.1116ZM12.6279 44.1847L15.6746 43.206L14.961 40.9847H12.6279V44.1847ZM12.6255 44.1823L15.8255 44.1822L15.8255 43.6823L15.673 43.2063L12.6255 44.1823ZM22.8082 21.6528L23.7899 24.6985L23.7933 24.6974L22.8082 21.6528ZM36.5791 23.3909L34.8713 26.097L36.5806 27.1758L38.2891 26.0956L36.5791 23.3909ZM50.3378 21.6528L51.32 18.6072L51.3144 18.6054L50.3378 21.6528ZM60.5425 44.1823L57.4948 43.2068L57.4923 43.2146L57.4898 43.2224L60.5425 44.1823ZM37.4628 68.1067L35.9223 65.3018L35.913 65.307L37.4628 68.1067ZM36.5864 65.1331C34.8191 65.1331 33.3864 66.5658 33.3864 68.3331C33.3864 70.1004 34.8191 71.5331 36.5864 71.5331V65.1331ZM36.5864 65.1331C36.8042 65.1331 37.033 65.1869 37.2431 65.3013L34.1819 70.9218C34.9373 71.3332 35.7649 71.5331 36.5864 71.5331V65.1331ZM37.2467 65.3033C36.9521 65.1424 32.4697 62.6758 27.5602 58.6293C22.57 54.5163 17.5756 49.1237 15.6746 43.206L9.58128 45.1634C12.0548 52.8633 18.2216 59.226 23.4896 63.568C28.8383 67.9764 33.711 70.6645 34.1783 70.9198L37.2467 65.3033ZM12.6279 40.9847C13.1869 40.9847 13.8189 41.1336 14.4009 41.5213C14.9629 41.8958 15.2978 42.3723 15.4876 42.7518C15.6712 43.1186 15.747 43.4468 15.782 43.6563C15.8007 43.7686 15.8113 43.8692 15.8174 43.9542C15.8204 43.9973 15.8225 44.0379 15.8237 44.0756C15.8244 44.0945 15.8248 44.1129 15.8251 44.1306C15.8252 44.1395 15.8253 44.1482 15.8254 44.1568C15.8254 44.1611 15.8255 44.1654 15.8255 44.1696C15.8255 44.1718 15.8255 44.1739 15.8255 44.176C15.8255 44.177 15.8255 44.1786 15.8255 44.1791C15.8255 44.1807 15.8255 44.1822 12.6255 44.1823C9.42551 44.1824 9.42551 44.1839 9.42551 44.1855C9.42551 44.186 9.42551 44.1876 9.42552 44.1886C9.42552 44.1907 9.42553 44.1928 9.42553 44.195C9.42555 44.1992 9.42558 44.2035 9.42561 44.2078C9.42568 44.2164 9.42578 44.2251 9.42593 44.234C9.42621 44.2518 9.42666 44.2701 9.42729 44.2891C9.42855 44.3268 9.43058 44.3674 9.43366 44.4106C9.43975 44.4958 9.45037 44.5966 9.46914 44.7091C9.50415 44.919 9.58013 45.2478 9.76398 45.6153C9.95412 45.9953 10.2895 46.4725 10.8522 46.8474C11.4348 47.2356 12.0677 47.3847 12.6279 47.3847V40.9847ZM15.673 43.2063C13.2805 35.736 16.1228 27.1697 23.7899 24.6985L21.8265 18.6071C9.7514 22.4991 6.47872 35.4814 9.57799 45.1583L15.673 43.2063ZM23.7933 24.6974C27.5173 23.4925 31.5828 24.0216 34.8713 26.097L38.287 20.6847C33.4059 17.6042 27.369 16.8139 21.8232 18.6081L23.7933 24.6974ZM38.2891 26.0956C41.4476 24.0988 45.722 23.5338 49.3612 24.7001L51.3144 18.6054C45.8688 16.8603 39.627 17.678 34.8691 20.6861L38.2891 26.0956ZM49.3557 24.6983C57.0374 27.1756 59.8835 35.7439 57.4948 43.2068L63.5901 45.1578C66.6884 35.4783 63.4 22.5029 51.32 18.6072L49.3557 24.6983ZM57.4898 43.2224C55.659 49.0444 50.6811 54.4279 45.6659 58.5666C40.7376 62.6336 36.2185 65.1392 35.9223 65.3019L39.0032 70.9115C39.4738 70.6531 44.3779 67.9273 49.7395 63.5028C55.0141 59.15 61.1927 52.7819 63.5951 45.1423L57.4898 43.2224ZM35.913 65.307C36.1223 65.1912 36.3549 65.1331 36.5864 65.1331V71.5331C37.4217 71.5331 38.258 71.3241 39.0126 70.9064L35.913 65.307Z"
                fill="#CE7C6D"
                mask="url(#path-3-inside-1_781_94451)"
              />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1.5458"
                  height="1.65273"
                >
                  <use
                    xlink:href="#image0_781_94451"
                    transform="scale(0.00309161 0.00330545)"
                  />
                </pattern>
                <linearGradient
                  id="paint0_linear_781_94451"
                  x1="72.6902"
                  y1="12.2685"
                  x2="34.7635"
                  y2="4.71307"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#E1AFA6" />
                  <stop offset="1" stop-color="#F4E2DF" />
                </linearGradient>
                <image
                  id="image0_781_94451"
                  width="500"
                  height="500"
                />
              </defs>
            </svg>
          </div>

          <div :class="`${classVariableName}-review-sucess-main-text`">
           Thank you!
          </div>
          <div :class="`${classVariableName}-review-sucess-secondary-text`">
            We are processing your review. We'll post it once we verify that it
            follows our guidelines. To know more, view our <b><u><a href="https://www.tirabeauty.com/page/terms-and-conditions">T&Cs</a></u></b>
          </div>
        </div>
      </template>
    </SidePanel>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import { classVariableName } from "../utils";
import SidePanel from "./common/SidePanel.vue";

export default defineComponent({
  name: "AddReviewSuccessSidePanel",
  components: {
    SidePanel,
  },
  data() {
    return {
      classVariableName: classVariableName,
    };
  },
  props: {
    onClose: Function,
  },
  methods: {
    gotoHomepage() {
      window.location.href = window.location.origin;
    },
  },
});
</script>

<style lang="scss" scoped>
@import "../assets/SidePanel.scss";
</style>